import { useTranslationsStore } from "@/library/stores/TranslationsStore";

export default class Translation {
  public static currentLanguage = "SK";
  public static defaultLanguage = "SK";
  public static store: any = null;

  public static initStore() {
    // Init TranslationsStore.ts
    return useTranslationsStore();
  }
  public static init() {
    let translObj = Object.assign({}, window.FormEngine.engineConfig.translations[this.defaultLanguage]);
    for (let control of window.FormEngine.structure.fields) {
      translObj[control[0]] = {
        Name: this.reaplceIndentationWithHTML(control[1].Name),
        Hint: this.reaplceIndentationWithHTML(control[1].Hint),
        Title: this.reaplceIndentationWithHTML(control[1].Title),
        HelpText: this.reaplceIndentationWithHTML(control[1].HelpText),
      };
    }
    for (let section of window.FormEngine.structure.sections) {
      if (section[1] && !section[1].IsTable) {
        translObj[section[0]] = {
          Name: this.reaplceIndentationWithHTML(section[1].Name),
          Hint: this.reaplceIndentationWithHTML(section[1].Hint),
          Title: this.reaplceIndentationWithHTML(section[1].Title),
        };
      }
    }
    if (!window.FormEngine.engineConfig.translations) {
      window.FormEngine.engineConfig.translations = {} as { [key: string]: any };
    }
    window.FormEngine.engineConfig.translations[this.defaultLanguage] = Object.assign({}, translObj);
  }

  public static reaplceIndentationWithHTML(toBeSearched: string) {
    if (toBeSearched) {
      let replaced = toBeSearched.replace(/(\r\n|\n|\r)/gm, "<br>");
      return replaced;
    } else {
      return toBeSearched;
    }
  }

  public static changeLanguage(languageCode: string) {
    if (languageCode !== this.currentLanguage) {
      this.currentLanguage = languageCode;
      window.FormEngine.form.errorBag.refreshErrors();
      window.FormEngine.formBuilder.currentLanguage = languageCode;
      window.FormEngine.form.app.reloadApp();
    }
  }
}
